import * as React from 'react';

const MapLoader = () => {

    return (
        <span id='map-loader-instance' className="ik-map-loader hidden"></span>
    )
}

export { MapLoader }